import miniToastr from 'mini-toastr'
import i18n from "../../localization/i18n";
import Vue from 'vue';
export default {
  state: {
    errorDetail: undefined
  },
  mutations: {
    NOTIFY_ERROR(state, data) {
      let items = [];
      if (data !== undefined) {
        items = [];
        let keys = Object.getOwnPropertyNames(data);
        for (let key of keys) {
          if (data[key] !== undefined && data[key].length > 0) {
            for (let e of data[key]) {
              items.push(e);
            }
          }
        }
      }
      state.errorDetail = items;
      miniToastr['error'](items, i18n.t('base.error'), 5000);
    },
    NOTIFY_REMOVE(state, index) {
      let temp = state.errorDetail;
      temp.splice(index, 1);
      Vue.set(state, 'errorDetail', [...temp]);
    },
    NOTIFY_RESET(state) {
      Vue.set(state, 'errorDetail', []);
    }
  },
  actions: {
    ADD_ERROR({commit}, error) {
      commit('NOTIFY_ERROR', error);
    },
    NOTIFY_MSG(store, data) {
      const show = (type, message, title, duration=5000) => {
        if (window.isCordova !== undefined && window.isCordova()) {
          window.plugins.toast.show(`${title}: ${message}`, duration, 'bottom')
        } else {
          miniToastr[type](message, title, duration)
        }
      }
      if (typeof data === 'string') {
        const locale = i18n.t(data);
        show(locale.type, locale.message, locale.title, 5000)
      } else {
        show(data.type, data.message, data.title, 5000)
      }
    },
    NOTIFY_ERROR(store, error) {
      const show = (type, message, title, duration=5000) => {
        if (window.isCordova !== undefined && window.isCordova()) {
          window.plugins.toast.show(`${title}: ${message}`, duration, 'bottom')
        } else {
          miniToastr[type](message, title, duration)
        }
      }

      if (error === undefined || error.response === undefined)
        show('error', error, i18n.t('base.error'), 5000);
      else if (error.response.status === 403) store.dispatch('error/missingRights', {value: true});

      try {
        if (error.response.data instanceof Object) {

          //Data annotation error
          if (error.response.data.errors instanceof Object) {
            store.commit('NOTIFY_ERROR', error.response.data.errors);
          } else if (error.response.data.detail) {
            show('error', error.response.data.detail, i18n.t('base.error'), 5000);
          } else if (error.response.data.value) {
            show('error', error.response.data.value, i18n.t('base.error'), 5000);
          } else {
            show('error', error.response.data.title, i18n.t('base.error'), 5000);
          }
        } else
          show('error', i18n.t(error.response.data), i18n.t('base.error'), 5000);
      }
      catch (e) {
        console.error(e);
      }
    },
    NOTIFY_REMOVE(store, index) {
      store.commit('NOTIFY_REMOVE', index);
    },
    NOTIFY_RESET(store) {
      store.commit('NOTIFY_RESET');
    }
  }
}
